module.exports = __webpack_public_path__ + "static/media/fa-solid-900.750e40b5.woff2";